import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export default function SettingsPage() {
  const navigate = useNavigate();
  const { currentUser, logout } = useAuth();

  if (!currentUser) {
    navigate("/auth");
    return null;
  }

  function handleLogout() {
    logout();
    navigate("/");
  }

  const sections = [
    {
      title: "account",
      items: [
        { icon: "👤", label: "My Profile",  sub: currentUser.username,  onClick: () => navigate("/profile") },
        { icon: "📋", label: "My Lists",    sub: "watchlist, favourites…", onClick: () => navigate("/lists") },
      ],
    },
    {
      title: "support",
      items: [
        { icon: "💬", label: "Discussions", sub: "browse the community feed", onClick: () => navigate("/discussions") },
        { icon: "🎬", label: "Browse Movies", sub: "explore the catalogue",     onClick: () => navigate("/") },
      ],
    },
  ];

  return (
    <div style={{ minHeight: "100vh", background: "#0b0b0c" }}>
      <div style={{ maxWidth: 560, margin: "0 auto", padding: "48px 20px" }}>

        <button
          onClick={() => navigate(-1)}
          style={{ background: "none", border: "none", color: "#55555e", cursor: "pointer", fontSize: 13, marginBottom: 32, fontFamily: "'Plus Jakarta Sans', sans-serif" }}
        >← back</button>

        <h1 style={{ fontFamily: "'Bricolage Grotesque', sans-serif", fontSize: 26, fontWeight: 800, color: "#f0f0f0", marginBottom: 32, letterSpacing: "-0.5px" }}>
          Settings
        </h1>

        {sections.map(section => (
          <div key={section.title} style={{ marginBottom: 20 }}>
            <div style={{ fontSize: 10, color: "#55555e", textTransform: "uppercase", letterSpacing: "0.8px", marginBottom: 10, fontFamily: "'Plus Jakarta Sans', sans-serif" }}>
              {section.title}
            </div>
            <div style={{ background: "#111113", border: "0.5px solid #252528", borderRadius: 14, overflow: "hidden" }}>
              {section.items.map(({ icon, label, sub, onClick }) => (
                <div key={label} onClick={onClick} style={{ display: "flex", alignItems: "center", gap: 14, padding: "14px 18px", cursor: "pointer", borderBottom: "0.5px solid #1c1c1f", transition: "background 0.1s" }}
                  onMouseEnter={e => e.currentTarget.style.background = "#161618"}
                  onMouseLeave={e => e.currentTarget.style.background = "transparent"}
                >
                  <span style={{ fontSize: 18, flexShrink: 0 }}>{icon}</span>
                  <div style={{ flex: 1, minWidth: 0 }}>
                    <div style={{ fontSize: 13, fontWeight: 600, color: "#c0c0c0", fontFamily: "'Plus Jakarta Sans', sans-serif" }}>{label}</div>
                    {sub && <div style={{ fontSize: 11, color: "#45454e", marginTop: 2, fontFamily: "'Plus Jakarta Sans', sans-serif", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{sub}</div>}
                  </div>
                  <span style={{ color: "#3a3a44", fontSize: 16 }}>›</span>
                </div>
              ))}
            </div>
          </div>
        ))}

        <div style={{ marginTop: 32 }}>
          <button
            onClick={handleLogout}
            style={{
              width: "100%", padding: "13px", borderRadius: 12,
              background: "transparent", border: "0.5px solid #3a1a1a",
              color: "#9a4a4a", fontSize: 13, fontWeight: 600,
              fontFamily: "'Plus Jakarta Sans', sans-serif", cursor: "pointer",
              transition: "background 0.15s",
            }}
            onMouseEnter={e => e.currentTarget.style.background = "#1a1010"}
            onMouseLeave={e => e.currentTarget.style.background = "transparent"}
          >
            sign out
          </button>
        </div>
      </div>
    </div>
  );
}
